export var PhoneNumberScore;
(function (PhoneNumberScore) {
    PhoneNumberScore["Green"] = "GREEN";
    PhoneNumberScore["Red"] = "RED";
    PhoneNumberScore["Yellow"] = "YELLOW";
})(PhoneNumberScore || (PhoneNumberScore = {}));
export var WabaReviewStatus;
(function (WabaReviewStatus) {
    WabaReviewStatus["Pending"] = "PENDING";
    WabaReviewStatus["Approved"] = "APPROVED";
    WabaReviewStatus["Rejected"] = "REJECTED";
})(WabaReviewStatus || (WabaReviewStatus = {}));
export var BusinessVerificationStatus;
(function (BusinessVerificationStatus) {
    BusinessVerificationStatus["PendingSubmission"] = "pendingSubmission";
    BusinessVerificationStatus["Pending"] = "pending";
    BusinessVerificationStatus["NotVerified"] = "notVerified";
    BusinessVerificationStatus["Verified"] = "verified";
})(BusinessVerificationStatus || (BusinessVerificationStatus = {}));
export var PhoneNumberStatus;
(function (PhoneNumberStatus) {
    PhoneNumberStatus["Connected"] = "CONNECTED";
    PhoneNumberStatus["Disconnected"] = "DISCONNECTED";
    PhoneNumberStatus["Pending"] = "PENDING";
    PhoneNumberStatus["Deleted"] = "DELETED";
    PhoneNumberStatus["Banned"] = "BANNED";
    PhoneNumberStatus["Restricted"] = "RESTRICTED";
    PhoneNumberStatus["RateLimited"] = "RATE_LIMITED";
    PhoneNumberStatus["Flagged"] = "FLAGGED";
    PhoneNumberStatus["Unknown"] = "UNKNOWN";
})(PhoneNumberStatus || (PhoneNumberStatus = {}));
